var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "alert alert-info p-1" },
    _vm._l(_vm.orders, function (o) {
      return _c(
        "p",
        [
          _c(
            "button",
            {
              staticClass: "btn btn-xs btn-info newWindowBtn",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.showInvoice(o.invoice_id)
                },
              },
            },
            [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
          ),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(o.invoice_id))]),
          _vm._v(" "),
          _c("strong", [
            _vm._v(
              _vm._s(Math.round(o.qty * 10) / 10) +
                "уп *\n    " +
                _vm._s(Math.round((o.price || o.income_price) * 10) / 10)
            ),
          ]),
          _vm._v("\n    ("),
          _c("i", { staticClass: "icon-fa icon-fa-eur" }),
          _vm._v(_vm._s(_vm.prices[o.id]) + ") "),
          _c(
            "span",
            {
              class: {
                red: _vm.costPrice < _vm.prices[o.id],
                green: _vm.costPrice > _vm.prices[o.id],
              },
            },
            [
              _vm._v(
                _vm._s(
                  Math.round((_vm.prices[o.id] - _vm.costPrice) * 100) / 100
                )
              ),
            ]
          ),
          _vm._v(" "),
          _vm.suppliers
            ? _c("span", [
                _vm._v(_vm._s(_vm.getSupplierNameById(o.supplier_id))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-popover",
            {
              staticClass: "d-inline",
              attrs: {
                placement: "right",
                trigger: "hover",
                delay: { show: 100, hide: 500 },
              },
            },
            [
              _c("span", { staticClass: "badge badge-info pointer" }, [
                _c("i", { staticClass: "icon-fa icon-fa-info" }),
              ]),
              _vm._v(" "),
              _c("template", { slot: "popover" }, [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.costPriceCalculation
                        ? _vm.costPriceCalculation(_vm.prices[o.id])
                        : "no data"
                    ),
                  },
                }),
              ]),
            ],
            2
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }